module.exports = __webpack_public_path__ + "img/fantasy.2951b620.svg";